import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Button, Flex } from "antd"

export default function LoadMoreButton({ currentPage, totalPages, loading, onLoadMore, totalAvailable }) {
  const { t } = useTranslation()

  const showLoadMore = currentPage < totalPages

  return (
    <Flex justify="center" align="center" className="p-md" style={{ marginTop: 16 }}>
      {showLoadMore ? (
        <Button variant="outlined" color="primary" onClick={onLoadMore} loading={loading}>
          {t("global.see_more")}
        </Button>
      ) : (
        <span style={{ opacity: 0.6 }}></span>
      )}
    </Flex>
  )
}

LoadMoreButton.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  onLoadMore: PropTypes.func.isRequired,
  totalAvailable: PropTypes.number.isRequired
}

LoadMoreButton.defaultProps = {
  loading: false
}
